import React from 'react';
import {
  getCargoDirection,
  getCargoStatus,
  isCargoOverdue,
} from '../../utils/companyShipments';
import { formatShipmentDate, getCarrierLabel, getTrackingUrl } from '../../utils/shipments';
import { BADGE, BADGE_BASE } from './reminderStyles';
import { useTranslation } from '../../i18n/LanguageContext';

/** Giriş hatırlatmasında tek bir bekleyen kargonun özeti. */
const CargoReminderItem = ({ shipment }) => {
  const { t } = useTranslation();
  const direction = getCargoDirection(shipment.direction);
  const status = getCargoStatus(shipment.direction, shipment.status);
  const overdue = isCargoOverdue(shipment);
  const carrier = getCarrierLabel(shipment.carrier);
  const trackingUrl = getTrackingUrl(shipment.carrier, shipment.trackingNumber);
  const expected = formatShipmentDate(shipment.expectedAt);
  const title = shipment.subject || shipment.content || direction.label;

  return (
    <li className="tw-space-y-1 tw-rounded-xl tw-bg-slate-500/[0.05] tw-px-3.5 tw-py-2.5 tw-text-sm dark:tw-bg-white/[0.04]">
      <div className="tw-flex tw-min-w-0 tw-items-center tw-gap-2">
        <span className="tw-min-w-0 tw-truncate tw-font-medium tw-text-slate-800 dark:tw-text-slate-100" title={title}>{title}</span>
        <span className={`${BADGE_BASE} ${overdue ? BADGE.urgent : BADGE.info}`}>{overdue ? t('loginReminders.cargo.overdue') : status.label}</span>
      </div>
      <div className="tw-flex tw-flex-wrap tw-gap-x-3 tw-gap-y-0.5 tw-text-xs tw-text-slate-500 dark:tw-text-slate-400">
        <span>
          {direction.shortLabel}
          {shipment.partyName ? ` · ${direction.partyLabel}: ${shipment.partyName}` : ''}
        </span>
        {(carrier || shipment.trackingNumber) && (
          <span>
            {carrier}
            {shipment.trackingNumber && (
              <>
                {carrier ? ' · ' : ''}
                {trackingUrl ? (
                  <a href={trackingUrl} target="_blank" rel="noopener noreferrer" className="tw-font-medium tw-text-sky-700 tw-underline tw-underline-offset-2 dark:tw-text-sky-300" onClick={(e) => e.stopPropagation()}>
                    {shipment.trackingNumber}
                  </a>
                ) : (
                  shipment.trackingNumber
                )}
              </>
            )}
          </span>
        )}
        {expected && <span>{t('loginReminders.cargo.expected', { date: expected })}</span>}
      </div>
    </li>
  );
};

export default CargoReminderItem;
